var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KillfeedItem',{class:[_vm.planterGrid, _vm.planterRole],attrs:{"event":_vm.event,"future":_vm.future}},[_c('img',{staticClass:"item-icon",attrs:{"src":"/images/spike/spike-minimap.png","title":_vm.plantSite}})])}
var staticRenderFns = []

export { render, staticRenderFns }